export default __webpack_public_path__ + "static/media/home.57d25f57.png";